import { z } from 'zod';

export const signInSchema = z.object({
  email: z.email(),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  // 'super_admin' must be here or the actual Super Admin's own sign-in
  // response fails runtime zod validation post-rename (the FE mirror of
  // the backend login-lockout risk — see discovr backend's
  // internal/users/handler.go LoginRequest validator tag).
  //
  // 'talent_manager' is deliberately NOT listed: it's a placeholder role
  // with an empty scope set in V2 (no login surface, no UI reachable via
  // it yet — creator/talent-manager apps are V3) per the backend's own
  // scopes_map.go. Add it here the same day it gains a real login path,
  // or it will hit this exact same zod-validation lockout the moment it does.
  role: z.enum(['super_admin', 'admin', 'admin_member', 'brand_owner', 'brand_admin', 'brand_member', 'creator']),
});

export type SignInInput = z.infer<typeof signInSchema>;
